module.exports = "/_next/static/images/qupital-wechat-qrcode-161f09aac823b4deaac7f8f435e606e7.jpg";